import React, { Component } from "react";
import { httpService } from "../../services/HttpService";
import { MerchantTariff } from "../../models/MerchantModel";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { createTabHeaderTemplate } from "../../components/ui";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import TariffDetails from "./TariffDetails";
import { Dropdown } from "primereact/dropdown";
import { SelectItem } from "../../models/SelectItem";
import { isMerchantProfileUpdateAllowed } from "../../authGuard";
import { Pencil, Plus, X } from "lucide-react";
import { TabView, TabPanel } from "primereact/tabview";
import BillTariff from "./BillTariff";
import UtilityBillsTariff from "./UtilityBillsTariff";

interface MerchantTariffProps {
    merchantId: string;
    isBillTariffActive?: boolean;
}

interface MerchantTariffState {
    tariffs: MerchantTariff[];
    isLoading: boolean;
    isTariffDetailsVisible: boolean;
    selectedTariff: MerchantTariff | null;
    activeTabIndex: number;
}

export default class MerchantTariffsComponent extends Component<MerchantTariffProps, MerchantTariffState> {
    merchants: SelectItem[] = [
        { label: "Merchant 1", value: "Merchant 1" },
        { label: "Merchant 2", value: "Merchant 2" },
        { label: "Merchant 3", value: "Merchant 3" },
        { label: "Merchant 4", value: "Merchant 4" },
    ];

    constructor(props: any) {
        super(props);

        this.state = {
            tariffs: [],
            isLoading: true,
            selectedTariff: null,
            isTariffDetailsVisible: false,
            activeTabIndex: 0, // Bill Tariff will be at index 0 when Merchant Tariffs is hidden
        };
    }

    textEditor(options: ColumnEditorOptions) {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback && options.editorCallback(e.target.value)} />;
    }

    dropDownEditor(options: ColumnEditorOptions) {
        return (
            <Dropdown
                value={options.value}
                options={this.merchants}
                optionLabel="label"
                optionValue="value"
                onChange={(e) => options.editorCallback && options.editorCallback(e.value)}
                placeholder="Select Merchant"
                filter
                itemTemplate={(option) => {
                    return <span>{option.label}</span>;
                }}
            />
        );
    }

    async componentDidMount() {
        const tariffs = await httpService.getMerchantTariffsById(this.props.merchantId);

        this.setState({ tariffs: tariffs, isLoading: false });
    }

    renderHeader = () => {
        return (
            <div className="table-header">
                <span className="p-input-icon-left align-right">
                    {isMerchantProfileUpdateAllowed() && (
                        <Button
                            label="Add Tariff"
                            outlined
                            icon={<Plus size={16} />}
                            onClick={() => this.addorEditTariff(this.getEmptyTariff())}
                        />
                    )}
                </span>
            </div>
        );
    };

    getEmptyTariff = (): MerchantTariff => {
        return { code: "", details: [], groupNames: [], id: "", name: "", totalUsers: 0, merchantName: "" };
    };

    addorEditTariff = (rowData: MerchantTariff) => {
        this.setState({ isTariffDetailsVisible: true, selectedTariff: rowData });
    };

    deleteTariff = (rowData: MerchantTariff) => {
        this.setState({ tariffs: this.state.tariffs.filter((tariff) => tariff.id != rowData.id) });
    };

    onTariffDetailsModalClose = () => {
        this.setState({ isTariffDetailsVisible: false });
    };

    actionBodyTemplate = (rowData: MerchantTariff) => {
        return (
            <>
                <button type="button" className="inline-flex items-center justify-center rounded-md p-2 hover:bg-neutral-100 transition-colors" tabIndex={0} onClick={() => this.addorEditTariff(rowData)}>
                    <Pencil size={16} className="cursor-pointer text-neutral-500 hover:text-primary-500 transition-colors" />
                </button>
                <button type="button" className="inline-flex items-center justify-center rounded-md p-2 hover:bg-neutral-100 transition-colors" tabIndex={0} onClick={() => this.deleteTariff(rowData)}>
                    <X size={16} className="cursor-pointer text-neutral-500 hover:text-danger-500 transition-colors" />
                </button>
            </>
        );
    };

    onActionButtonClick = (row: any) => { };

    render() {
        return (
            <div>
                {this.state.isTariffDetailsVisible && this.state.selectedTariff != null && (
                    <TariffDetails onHide={this.onTariffDetailsModalClose} tariff={this.state.selectedTariff} />
                )}
                    {this.props.isBillTariffActive ? (
                        <TabView
                            activeIndex={this.state.activeTabIndex}
                            onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                        >
                            <TabPanel
                                header="General Tariffs"
                                pt={{ content: { className: "!p-0" } }}
                                headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                            >
                                <BillTariff />
                            </TabPanel>
                            <TabPanel
                                header="Utility Bills Tariff"
                                pt={{ content: { className: "!p-0" } }}
                                headerTemplate={createTabHeaderTemplate(this.state.activeTabIndex)}
                            >
                                <UtilityBillsTariff merchantId={this.props.merchantId} />
                            </TabPanel>
                        </TabView>
                    ) : (
                        <div className="py-10 text-center text-sm text-neutral-400 dark:text-neutral-500">
                            Bill Tariff is not active for this merchant. Enable it from merchant configuration.
                        </div>
                    )}
            </div>
        );
    }
}
